import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { ContentCard, DetailsGrid } from '@indigo-ag/component-module';
import i18next from 'i18next';
import React from 'react';
import { currency, parseNumberToLocale } from 'shared';

const EMPTY_VALUE = `-`;

interface Props {
  accountCity?: string | null;
  accountState?: string | null;
  assetValue?: number | null;
  ownedLand?: number | null;
}

export const PatrimonyAssetValuation = ({ ownedLand, accountCity, accountState, assetValue }: Props) => {
  const region = accountCity && accountState ? `${accountCity}, ${accountState}` : EMPTY_VALUE;
  const value = assetValue != null ? currency.formatLocaleCurrency(assetValue, 'BRL') : EMPTY_VALUE;
  const ownedLandDisplay = ownedLand != null ? parseNumberToLocale(ownedLand) : EMPTY_VALUE;

  const items = [
    { label: i18next.t('ownedLand'), value: ownedLandDisplay },
    { label: i18next.t('region'), value: region },
    {
      label: i18next.t('value'),
      labelIcon: faInfoCircle,
      description: i18next.t('calculationsTooltip_patrimonyValuationValue'),
      value
    }
  ];

  return (
    <ContentCard titleText={i18next.t('patrimonyAssetValuation')}>
      <DetailsGrid items={items} columnWidth={250} />
    </ContentCard>
  );
};
